/* This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/.
 */

export class HotkeyDetector {
  static isPointerLockHotkey(event: MouseEvent): boolean {
    return (
      event.type === "mousedown" &&
      event.button === 0 &&
      event.ctrlKey &&
      event.shiftKey
    );
  }

  static isMenuHotkey(event: KeyboardEvent): boolean {
    return (
      event.type === "keydown" &&
      event.code === "KeyM" &&
      event.ctrlKey &&
      event.shiftKey
    );
  }

  static isFullscreenHotkey(event: KeyboardEvent): boolean {
    return (
      event.type === "keydown" &&
      event.code === "KeyF" &&
      event.ctrlKey &&
      event.shiftKey
    );
  }

  static isCloseTabHotkey(event: KeyboardEvent): boolean {
    return (
      event.type === "keydown" &&
      event.code === "KeyW" &&
      (event.ctrlKey || event.metaKey)
    );
  }

  static shouldBlockShortcut(event: KeyboardEvent): boolean {
    return (
      (event.code === "F5" && event.ctrlKey) ||
      (event.code === "KeyI" && event.ctrlKey && event.shiftKey) ||
      event.code === "F11"
    );
  }
}
